import React from 'react';
import { Box, lighten } from '@mui/material';
import { styled } from '@mui/system';
import { INQUIRY_STATUS_OPTIONS } from '@/utils/constants';

// Base colours per enquiry status. Matches the soft "Stage" chip look used on
// the Sales table (tinted background + solid colored left border).
const STATUS_COLOR: Record<string, string> = {
    new: '#C59939',       // Pending  - amber
    contacted: '#4A6EA1', // In Progress - blue
    closed: '#43C463',    // Addressed - green
};

const FALLBACK_COLOR = '#8891AA';

const Chip = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'baseColor',
})<{ baseColor: string }>(({ baseColor }) => ({
    display: 'inline-block',
    fontSize: '14px',
    fontWeight: 500,
    padding: '7px 14px',
    borderRadius: '5px',
    whiteSpace: 'nowrap',
    color: '#333',
    background: lighten(baseColor, 0.73),
    borderLeft: `3px solid ${baseColor}`,
}));

export default function InquiryStatusChip({ status }: { status?: string }): React.JSX.Element {
    const label = INQUIRY_STATUS_OPTIONS.find((option) => option.value === status)?.label ?? status ?? '-';
    const baseColor = (status && STATUS_COLOR[status]) || FALLBACK_COLOR;
    return <Chip baseColor={baseColor}>{label}</Chip>;
}
